<div #outsideModal class="modal">
  <div #modalBody class="modal-content">
    <div class="modal-header">Comptes disponibles</div>
    <div class="modal-body">
      <frg-form-input
        *ngIf="formGroup"
        id="email"
        type="ngSelect"
        label="Comptes"
        [selectValue]="emails"
        [formGroup]="formGroup"
        [control]="formGroup.get('email')"
        [isClearableSelect]="false"
      ></frg-form-input>

      <div class="button-container">
        <frg-button (activated)="selectAccount()" [disabled]="!formGroup.valid">
          <div title="Valider">Valider</div>
        </frg-button>
      </div>
    </div>
  </div>
</div>
<div class="modal-background"></div>